import React from 'react';
import { authorDetailsPropTypes } from './AuthorDetailsPropTypes';
import Author from '@Theme/natucare/components/Tooltip/components/Author/Author';
import Hr from '@Theme/natucare/components/Tooltip/components/Hr/Hr';
import Text from '@Theme/natucare/components/Tooltip/components/Text/Text';
import Socials from '@Theme/natucare/components/Tooltip/components/Socials/Socials';
const AuthorDetails = ({
  href,
  picture,
  title,
  name,
  role,
  details
}) => {
  if (!picture) {
    return null;
  }
  const authorProps = {
    href,
    picture,
    title,
    name,
    role
  };
  const {
    description,
    socials,
    footerText
  } = details;
  const isAtLeastOneSocialLink = Object.values(socials).some(val => !!val);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Author, authorProps), /*#__PURE__*/React.createElement(Hr, null), description && /*#__PURE__*/React.createElement(Text, {
    html: description
  }), isAtLeastOneSocialLink && /*#__PURE__*/React.createElement(Socials, {
    socials: socials
  }), footerText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hr, null), /*#__PURE__*/React.createElement(Text, {
    html: footerText
  })));
};
export default AuthorDetails;